import React from 'react';
import { CheckCircle2, ArrowRight, FileSearch, Sparkles, Clock, Shield, Users } from 'lucide-react';
import { Button } from '../ui/button';
import { diagnosticData, contactData } from '../../data/mock';

const DiagnosticSection = () => {
  const benefits = [
    { icon: Clock, text: 'Resultado em até 48h' },
    { icon: Shield, text: 'Sigilo total garantido' },
    { icon: Users, text: 'Atendimento personalizado' },
  ];

  return (
    <section id="diagnostico" className="py-20 md:py-28 bg-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-emerald-50 to-transparent" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-slate-100 rounded-full blur-3xl opacity-50" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-100 rounded-full">
              <FileSearch className="w-4 h-4 text-emerald-600" />
              <span className="text-emerald-700 text-sm font-semibold">Primeiro Passo</span>
            </div>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
              {diagnosticData.title}
            </h2>

            <p className="text-lg text-slate-600 leading-relaxed">
              {diagnosticData.description}
            </p>

            {/* Features List */}
            <ul className="space-y-4">
              {diagnosticData.features.map((feature, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700 font-medium">{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Lead Capture Card */}
          <div className="relative">
            <div className="bg-slate-900 rounded-3xl p-8 md:p-10 shadow-2xl">
              {/* Badge */}
              <div className="absolute -top-4 -right-4 bg-amber-400 text-slate-900 px-6 py-2 rounded-full font-bold text-sm shadow-lg flex items-center gap-2">
                <Sparkles className="w-4 h-4" />
                Gratuito
              </div>

              {/* Header */}
              <div className="text-center mb-8">
                <div className="w-16 h-16 bg-emerald-500/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <FileSearch className="w-8 h-8 text-emerald-400" />
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                  Análise Técnica de Crédito
                </h3>
                <p className="text-slate-400">
                  Descubra o que está impedindo sua aprovação
                </p>
              </div>

              {/* Benefits */}
              <div className="flex flex-wrap justify-center gap-4 mb-8">
                {benefits.map((benefit, index) => (
                  <div key={index} className="flex items-center gap-2 text-slate-300 text-sm">
                    <benefit.icon className="w-4 h-4 text-emerald-400" />
                    <span>{benefit.text}</span>
                  </div>
                ))}
              </div>

              {/* Divider */}
              <div className="border-t border-slate-700 my-8" />

              {/* What's included */}
              <div className="space-y-4 mb-8">
                <p className="text-slate-400 text-sm font-medium uppercase tracking-wider text-center">
                  Você vai descobrir:
                </p>
                <ul className="space-y-3">
                  <li className="flex items-center gap-3 text-white">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                    <span className="text-sm">Por que seu crédito está sendo negado</span>
                  </li>
                  <li className="flex items-center gap-3 text-white">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                    <span className="text-sm">Quais dados estão irregulares</span>
                  </li>
                  <li className="flex items-center gap-3 text-white">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                    <span className="text-sm">O caminho para regularização</span>
                  </li>
                </ul>
              </div>

              {/* CTA Button */}
              <Button
                size="lg"
                className="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-semibold text-lg py-6 rounded-xl shadow-lg shadow-emerald-600/30 hover:shadow-xl transition-all duration-300"
                asChild
              >
                <a href={contactData.whatsappLink} target="_blank" rel="noopener noreferrer">
                  Solicitar Análise Técnica
                  <ArrowRight className="w-5 h-5 ml-2" />
                </a>
              </Button>

              {/* Trust text */}
              <p className="text-slate-500 text-xs text-center mt-4">
                Seus dados estão protegidos e não serão compartilhados
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiagnosticSection;
